import type { GetContractsResponse } from '@weft/api-definition';
import { GetContractsResponseSchema } from '@weft/api-definition';
import { purge, withDefault } from '@weft/utils';
import type { QueryClient } from 'react-query';
import { useQuery, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';
import { CONTRACTS_PAGE_SIZE } from './use-contracts-consts';

type UseContractsPayload = Parameters<ReturnType<typeof getPrivateApi>['getContracts']>[0];

export function useContracts(payload: UseContractsPayload = {}, options?: CustomUseQueryOptions<GetContractsResponse>) {
  const queryClient = useQueryClient();

  return useQuery(['contracts', 'contract', ...purge(Object.values(payload))], async ({ signal }) => {
    const api = getPrivateApi();
    await cancelGetContractsQueries(queryClient);

    const getContractsResponses = await api.getContracts({
      ...payload,
      pageSize: withDefault(payload.pageSize, CONTRACTS_PAGE_SIZE),
      page: withDefault(payload.page, 0),
    }, { signal });

    return GetContractsResponseSchema.parse(getContractsResponses);
  }, {
    keepPreviousData: true,
    ...options,
  });
}

async function cancelGetContractsQueries(queryClient: QueryClient) {
  await queryClient.cancelQueries({
    predicate: (query) => query.queryKey[0] === 'contracts',
  });
}